import { render } from "./Aanbod.vue?vue&type=template&id=cbdc913c"
import script from "./Aanbod.vue?vue&type=script&lang=js"
export * from "./Aanbod.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__